import { render, staticRenderFns } from "./BaseTabPhase2.9.vue?vue&type=template&id=4ea2da7d"
import script from "./BaseTabPhase2.9.vue?vue&type=script&lang=js"
export * from "./BaseTabPhase2.9.vue?vue&type=script&lang=js"
import style0 from "./BaseTabPhase2.9.vue?vue&type=style&index=0&id=4ea2da7d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports